import { LANGUAGES, LocalizedText } from 'apollo/localizedTypes';

const toFormLocalizedText = (value?: LocalizedText): LocalizedText =>
  LANGUAGES.reduce(
    (mapped, language) => ({ ...mapped, [language]: value?.[language] || '' }),
    {}
  ) as LocalizedText;

export default toFormLocalizedText;
